import styled from 'styled-components'
import tokens from '@gympass/yoga-tokens'
import { Card as YogaCard } from '@gympass/yoga'

export const Card = styled(YogaCard)`
  padding: 24px;
  margin-top: 64px;
  margin-bottom: 64px;

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    margin-top: 46px;
    margin-bottom: 96px;
  }
`

export const CardHeader = styled(YogaCard.Header)`
  margin-bottom: 24px;
`

export const CardTitle = styled.h6`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  margin: 0;

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    font-size: 16px;
    line-height: 29px;
  }
`

export const CardRow = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`
export const Description = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  margin: 0;

  span {
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    align-self: flex-start;
  }

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    font-size: 14px;
    line-height: 17px;
  }
`

export const Value = styled.p(
  () => `
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  margin: 0;

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    font-size: 14px;
    line-height: 17px;
  }
`
)

export const Divider = styled.hr`
  margin-top: 24px;
  margin-bottom: 24px;
  border: none;
  height: 1px;
  background-color: #000000;
  opacity: 0.15;
`

export const TotalWrapper = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #001027;

  span {
    margin-left: 2px;
    font-size: 24px;
    font-weight: 500;
  }
`

export const CardFooter = styled.section`
  margin-top: 32px;
`

export const Body2 = styled.p`
  margin: 0;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
`
